export default __webpack_public_path__ + "static/media/eco.15059330.jpg";